"use client";

import { yearlySavingsPercent, type BillingInterval } from "@/lib/billing/planConfig";

/** Monthly / Yearly switch. The saving is computed from the real prices. */
export function IntervalToggle({
  value,
  onChange,
  size = "md",
}: {
  value: BillingInterval;
  onChange: (v: BillingInterval) => void;
  size?: "sm" | "md";
}) {
  const save = Math.min(yearlySavingsPercent("pro"), yearlySavingsPercent("studio"));
  const pad = size === "sm" ? "px-3 py-1 text-xs" : "px-4 py-1.5 text-sm";
  return (
    <div
      role="radiogroup"
      aria-label="Billing period"
      className="inline-flex items-center gap-1 rounded-full border border-[#2a475e] bg-[#131c28] p-1"
    >
      {(["month", "year"] as const).map((v) => {
        const active = v === value;
        return (
          <button
            key={v}
            type="button"
            role="radio"
            aria-checked={active}
            onClick={() => onChange(v)}
            className={`flex items-center gap-2 rounded-full font-medium transition-colors ${pad} ${
              active ? "bg-[#2a475e] text-white" : "text-[#8f98a0] hover:text-white"
            }`}
          >
            {v === "month" ? "Monthly" : "Yearly"}
            {v === "year" && (
              <span
                className={`rounded-full px-1.5 py-0.5 text-[10px] font-semibold ${
                  active ? "bg-[#a4d007] text-[#0d151e]" : "bg-[#a4d007]/15 text-[#a4d007]"
                }`}
              >
                −{save}%
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}
